module.exports = __webpack_public_path__ + "img/impact-in-action-mobile.dbbcff15.webp";